define("shared/components/shared/post/secondary/toggle", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class={{@class}}>
    <div class="cPM--composerTool__divider"></div>
    {{! Saved Captions }}
    <Shared::Ui::Button
      @class={{concat-classes
        "cPM--composerTool__item qa--savedCaptionBtn"
        (if this.isSavedCaptionsActive "is--active")
        (if @isFirstComment "qa--fc_add_savedCaption")
      }}
      @variant="unstyled"
      {{on "click" this.toggleSavedCaptions}}
    >
      {{svg-jar "template" class="o--icon--sm"}}
      <span data-test-id="captions-toggle">
        {{t "post.body.saved_captions"}}
      </span>
    </Shared::Ui::Button>
    {{! Hashtag Suggestions }}
    {{#if this.showHashtagSuggestions}}
      <Shared::Ui::Button
        @class={{concat-classes
          "cPM--composerTool__item qa--hashtagSuggestionsBtn at--onboardingV1__hashtagSuggestions at--hashtagAnalyticsUpgrade__hashtagSuggestionBtn"
          (if this.isHashtagSuggestionsActive "is--active")
          (if @isFirstComment "qa--fc_add_hashtags")
        }}
        @variant="unstyled"
        {{on "click" this.toggleHashtagSuggestions}}
      >
        {{svg-jar "smart-hashtag" class="o--icon--sm"}}
        <span class="qa--hashtagSuggestions_suggestBtn" data-test-id="hashtags-toggle">
          {{t "shared_phrases.hashtag_suggestions"}}
        </span>
      </Shared::Ui::Button>
    {{/if}}
  </div>
  */
  {
    "id": "u/g8Rgp5",
    "block": "[[[10,0],[15,0,[30,1]],[12],[1,\"\\n  \"],[10,0],[14,0,\"cPM--composerTool__divider\"],[12],[13],[1,\"\\n\"],[1,\"  \"],[8,[39,0],[[4,[38,3],[\"click\",[30,0,[\"toggleSavedCaptions\"]]],null]],[[\"@class\",\"@variant\"],[[28,[37,1],[\"cPM--composerTool__item qa--savedCaptionBtn\",[52,[30,0,[\"isSavedCaptionsActive\"]],\"is--active\"],[52,[30,2],\"qa--fc_add_savedCaption\"]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,4],[\"template\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n    \"],[10,1],[14,\"data-test-id\",\"captions-toggle\"],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"post.body.saved_captions\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[41,[30,0,[\"showHashtagSuggestions\"]],[[[1,\"    \"],[8,[39,0],[[4,[38,3],[\"click\",[30,0,[\"toggleHashtagSuggestions\"]]],null]],[[\"@class\",\"@variant\"],[[28,[37,1],[\"cPM--composerTool__item qa--hashtagSuggestionsBtn at--onboardingV1__hashtagSuggestions at--hashtagAnalyticsUpgrade__hashtagSuggestionBtn\",[52,[30,0,[\"isHashtagSuggestionsActive\"]],\"is--active\"],[52,[30,2],\"qa--fc_add_hashtags\"]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"smart-hashtag\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n      \"],[10,1],[14,0,\"qa--hashtagSuggestions_suggestBtn\"],[14,\"data-test-id\",\"hashtags-toggle\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"shared_phrases.hashtag_suggestions\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13]],[\"@class\",\"@isFirstComment\"],false,[\"shared/ui/button\",\"concat-classes\",\"if\",\"on\",\"svg-jar\",\"t\"]]",
    "moduleName": "shared/components/shared/post/secondary/toggle.hbs",
    "isStrictMode": false
  });

  let ToggleComponent = (_class = class ToggleComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "secondaryModal", _descriptor2, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get isHashtagSuggestionsActive() {
      return this.secondaryModal.isHashtagSuggestionsModalActive(this.args.postElementId, this.args.targetLocation);
    }

    get isSavedCaptionsActive() {
      return this.secondaryModal.isSavedCaptionsModalActive(this.args.postElementId, this.args.targetLocation);
    }

    get showHashtagSuggestions() {
      if (this.args.mediaItem) {
        return true;
      }

      const validCaption = !this.args.post?.exceededHashtagLimit && !this.args.post?.exceededCharacterLimit;

      const validSocialProfile = this.args.posts?.any(post => this._canHashtagSuggestions(post.get('socialProfile'))) || this.args.post && this._canHashtagSuggestions(this.args.post.socialProfile);

      return validCaption && validSocialProfile;
    }

    _canHashtagSuggestions(socialProfile) {
      if (socialProfile?.get('isTiktok') || socialProfile?.get('isPinterest') || socialProfile?.get('isLinkedin')) {
        return false;
      }

      return true;
    }

    toggleHashtagSuggestions() {
      if (!this.args.isDisabled) {
        this.args.toggleHashtagSuggestions();
      }
    }

    toggleSavedCaptions() {
      if (!this.args.isDisabled) {
        this.args.toggleSavedCaptions();
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "toggleHashtagSuggestions", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleHashtagSuggestions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSavedCaptions", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSavedCaptions"), _class.prototype)), _class);
  _exports.default = ToggleComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ToggleComponent);
});